import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=ce8d51bc"
import script from "./FullPage.vue?vue&type=script&lang=js"
export * from "./FullPage.vue?vue&type=script&lang=js"
import style0 from "./FullPage.vue?vue&type=style&index=0&id=ce8d51bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports